import config from "../config/config";
import AuthN from '../services/authnApi';
import { useEffect, useState } from 'react';

// アイコン共通パス
const ICON_BASE = config.icons.baseUrl;
// URL
const MENU_URLS = config.urls.menu;

// メニュー項目（アイコンとURLリンクを持つ場合は合わせて設定）
const MENU_ITEMS = {
  close: {
    label: '閉じる',
  },
  updateNotice: {
    label: 'アップデートしました！',
    url: MENU_URLS.updateNotice,
    icon: `${ICON_BASE}${config.icons.notifications}`,
  },
  help: {
    label: 'ヘルプ',
    url: MENU_URLS.help,
    icon: `${ICON_BASE}${config.icons.help}`,
  },
  inquiry: {
    label: 'お問い合わせ',
    url: MENU_URLS.inquiry,
    icon: `${ICON_BASE}${config.icons.mail}`,
  },
  myPage: {
    label: 'マイページ(保存済みスポット)',
    url: MENU_URLS.myPage,
    icon: `${ICON_BASE}${config.icons.person}`,
  },
  logout: {
    label: 'ログアウト',
    url: MENU_URLS.logout,
    icon: `${ICON_BASE}${config.icons.logout}`,
  },
  login: {
    label: 'ログイン',
    url: MENU_URLS.login,
    icon: `${ICON_BASE}${config.icons.person}`,
  },
  japanMap: {
    label: '日本地図',
    url: MENU_URLS.japanMap,
    icon: `${ICON_BASE}${config.icons.map}`,
  },
  addressSearch: {
    label: '住所検索',
    url: MENU_URLS.addressSearch,
    icon: `${ICON_BASE}${config.icons.building}`,
  },
  stationSearch: {
    label: '駅検索',
    url: MENU_URLS.stationSearch,
    icon: `${ICON_BASE}${config.icons.directionsTrain}`,
  },
  zipSearch: {
    label: '郵便番号検索',
    url: MENU_URLS.zipSearch,
    icon: `${ICON_BASE}${config.icons.postOffice}`,
  },
  transit: {
    label: '鉄道乗換案内',
    url: MENU_URLS.transit,
    icon: `${ICON_BASE}${config.icons.directionsTrain}`,
  },
  timetable: {
    label: '時刻表',
    url: MENU_URLS.timetable,
    icon: `${ICON_BASE}${config.icons.calendarClock}`,
  },
  phonebook: {
    label: '電話帳',
    url: MENU_URLS.phonebook,
    icon: `${ICON_BASE}${config.icons.phone}`,
  },
  weather: {
    label: '天気',
    url: MENU_URLS.weather,
    icon: `${ICON_BASE}${config.icons.weather}`,
  },
  news: {
    label: 'ニュース',
    url: MENU_URLS.news,
    icon: `${ICON_BASE}${config.icons.news}`,
  },
  touristMap: {
    label: '観光マップ',
    url: MENU_URLS.touristMap,
    icon: `${ICON_BASE}${config.icons.tourism}`,
  },
  apps: {
    label: 'アプリ一覧',
    url: MENU_URLS.apps,
    icon: `${ICON_BASE}${config.icons.apps}`,
  },
  sitemap: {
    label: 'サイトマップ',
    url: MENU_URLS.sitemap,
    icon: `${ICON_BASE}${config.icons.sitemap}`,
  },
  terms: {
    label: '利用規約',
    url: MENU_URLS.terms,
    icon: `${ICON_BASE}${config.icons.notes}`,
  },
  privacyPolicy: {
    label: '個人情報保護方針',
    url: MENU_URLS.privacyPolicy,
    icon: `${ICON_BASE}${config.icons.you}`,
  },
  personalInfoHandling: {
    label: '個人情報の取り扱い',
    url: MENU_URLS.personalInfoHandling,
    icon: `${ICON_BASE}${config.icons.shieldPerson}`,
  },
  company: {
    label: '会社概要',
    url: MENU_URLS.company,
    icon: `${ICON_BASE}${config.icons.building}`,
  },
};

const Menu = ({ isOpen, onClose, isMobileDevice }) => {
  const [isLogin, setIsLogin] = useState(false);

  useEffect(() => {
    AuthN.setUrl(process.env.REACT_APP_API_AUTHN_URL);
    AuthN.refreshToken();
    const accessToken = AuthN.getAccessToken();
    if (accessToken) {
      // アクセストークンが存在する場合はログイン済み
      setIsLogin(true);
    }
    return () => {
    };
  }, []);

  // オーバーレイ（背景）自身が押された時だけ閉じる
  // e.target: 実際に押された要素
  // e.currentTarget: ハンドラを付けた要素（=オーバーレイ）
  const handleOverlayPointerDown = (e) => {
    const clickedOverlayItself = (e.target === e.currentTarget);
    if (!clickedOverlayItself) {
      return;
    }
    onClose();
  };

  if (!isOpen) {
    return null;
  }

  return (
    <>
      <nav id="setting-menu" className="setting-menu">
        <div className="menu-header">
          <button
            type="button"
            id="close-menu"
            className="close-menu"
            onClick={e => {
              e.preventDefault();
              onClose();
            }}>
            {MENU_ITEMS.close.label}
          </button>
        </div>

        {/* <!-- ★★★ お知らせスペース ★★★ --> */}
        <div className="menu-notice">
          <a href={MENU_ITEMS.updateNotice.url} className="notice-link" target="_blank"
            rel="noopener noreferrer">
            <i
              className="svg-icon-blue"
              style={{ backgroundImage: `url('${MENU_ITEMS.updateNotice.icon}')` }}
            ></i>
            {MENU_ITEMS.updateNotice.label}
          </a>
        </div>

        <div className="menu-items">
          {/* <!-- サポート --> */}
          <div className="menu-section">
            <a href={MENU_ITEMS.help.url} className="menu-link important">
              <i
                className="svg-icon-blue"
                style={{ backgroundImage: `url('${MENU_ITEMS.help.icon}')` }}
              ></i>
              {MENU_ITEMS.help.label}
            </a>
            <a href={MENU_ITEMS.inquiry.url} className="menu-link important">
              <i
                className="svg-icon-blue"
                style={{ backgroundImage: `url('${MENU_ITEMS.inquiry.icon}')` }}
              ></i>
              {MENU_ITEMS.inquiry.label}
            </a>
          </div>

          {/* <!-- アカウント関連 --> */}
          <div className="menu-section">
            {isLogin
              ? <>
                <a href={MENU_ITEMS.myPage.url} className="menu-link">
                  <i
                    className="svg-icon-blue"
                    style={{ backgroundImage: `url('${MENU_ITEMS.myPage.icon}')` }}
                  ></i>
                  {MENU_ITEMS.myPage.label}
                </a>
                <a href={MENU_ITEMS.logout.url} className="menu-link">
                  <i className="svg-icon-blue"
                    style={{ backgroundImage: `url('${MENU_ITEMS.logout.icon}')` }}
                  ></i>
                  {MENU_ITEMS.logout.label}
                </a>
              </>
              : <a href={MENU_ITEMS.login.url} className="menu-link">
                <i
                  className="svg-icon-blue"
                  style={{ backgroundImage: `url('${MENU_ITEMS.login.icon}')` }}
                ></i>
                {MENU_ITEMS.login.label}
              </a>
            }

          </div>
          {/* <!-- 地図検索関連 --> */}
          <div className="menu-section">
            <a href={MENU_ITEMS.japanMap.url} className="menu-link">
              <i
                className="svg-icon-blue"
                style={{ backgroundImage: `url('${MENU_ITEMS.japanMap.icon}')` }}
              ></i>
              {MENU_ITEMS.japanMap.label}
            </a>
            <a href={MENU_ITEMS.addressSearch.url} className="menu-link">
              <i
                className="svg-icon-blue"
                style={{ backgroundImage: `url('${MENU_ITEMS.addressSearch.icon}')` }}
              ></i>
              {MENU_ITEMS.addressSearch.label}
            </a>
            <a href={MENU_ITEMS.stationSearch.url} className="menu-link">
              <i
                className="svg-icon-blue"
                style={{ backgroundImage: `url('${MENU_ITEMS.stationSearch.icon}')` }}
              ></i>
              {MENU_ITEMS.stationSearch.label}
            </a>
            <a href={MENU_ITEMS.zipSearch.url} className="menu-link">
              <i
                className="svg-icon-blue"
                style={{ backgroundImage: `url('${MENU_ITEMS.zipSearch.icon}')` }}
              ></i>
              {MENU_ITEMS.zipSearch.label}
            </a>
          </div>

          {/* <!-- ルート検索関連 --> */}
          {isMobileDevice &&
            <div className="menu-section">
              <a href={MENU_ITEMS.transit.url} className="menu-link">
                <i
                  className="svg-icon-blue"
                  style={{ backgroundImage: `url('${MENU_ITEMS.transit.icon}')` }}
                ></i>
                {MENU_ITEMS.transit.label}
              </a>
              <a href={MENU_ITEMS.timetable.url} className="menu-link">
                <i
                  className="svg-icon-blue"
                  style={{ backgroundImage: `url('${MENU_ITEMS.timetable.icon}')` }}
                ></i>
                {MENU_ITEMS.timetable.label}
              </a>
            </div>
          }

          {/* <!-- コンテンツ関連 --> */}
          <div className="menu-section">
            <a href={MENU_ITEMS.phonebook.url} className="menu-link">
              <i
                className="svg-icon-blue"
                style={{ backgroundImage: `url('${MENU_ITEMS.phonebook.icon}')` }}
              ></i>
              {MENU_ITEMS.phonebook.label}
            </a>
            <a href={MENU_ITEMS.weather.url} className="menu-link">
              <i
                className="svg-icon-blue"
                style={{ backgroundImage: `url('${MENU_ITEMS.weather.icon}')` }}
              ></i>
              {MENU_ITEMS.weather.label}
            </a>
            <a href={MENU_ITEMS.news.url} className="menu-link">
              <i
                className="svg-icon-blue"
                style={{ backgroundImage: `url('${MENU_ITEMS.news.icon}')` }}
              ></i>
              {MENU_ITEMS.news.label}
            </a>
            <a href={MENU_ITEMS.touristMap.url} className="menu-link">
              <i
                className="svg-icon-blue"
                style={{ backgroundImage: `url('${MENU_ITEMS.touristMap.icon}')` }}
              ></i>
              {MENU_ITEMS.touristMap.label}
            </a>
          </div>

          {/* <!-- アプリ関連 --> */}
          <div className="menu-section">
            <a href={MENU_ITEMS.apps.url} className="menu-link">
              <i
                className="svg-icon-blue"
                style={{ backgroundImage: `url('${MENU_ITEMS.apps.icon}')` }}
              ></i>
              {MENU_ITEMS.apps.label}
            </a>
          </div>

          {/* <!-- サイトマップ --> */}
          <div className="menu-section">
            <a href={MENU_ITEMS.sitemap.url} className="menu-link">
              <i
                className="svg-icon-blue"
                style={{ backgroundImage: `url('${MENU_ITEMS.sitemap.icon}')` }}>
              </i>
              {MENU_ITEMS.sitemap.label}
            </a>
          </div>

          {/* <!-- その他 --> */}
          <div className="menu-section">
            <a href={MENU_ITEMS.terms.url} className="menu-link">
              <i
                className="svg-icon-blue"
                style={{ backgroundImage: `url('${MENU_ITEMS.terms.icon}')` }}
              ></i>
              {MENU_ITEMS.terms.label}
            </a>
            <a href={MENU_ITEMS.privacyPolicy.url} className="menu-link">
              <i
                className="svg-icon-blue"
                style={{ backgroundImage: `url('${MENU_ITEMS.privacyPolicy.icon}')` }}
              ></i>
              {MENU_ITEMS.privacyPolicy.label}
            </a>
            <a href={MENU_ITEMS.personalInfoHandling.url} className="menu-link">
              <i
                className="svg-icon-blue"
                style={{ backgroundImage: `url('${MENU_ITEMS.personalInfoHandling.icon}')` }}
              ></i>
              {MENU_ITEMS.personalInfoHandling.label}
            </a>
            <a href={MENU_ITEMS.company.url} className="menu-link">
              <i
                className="svg-icon-blue"
                style={{ backgroundImage: `url('${MENU_ITEMS.company.icon}')` }}
              ></i>
              {MENU_ITEMS.company.label}
            </a>
          </div>
        </div>
      </nav>

      {/* メニュー外（背景）を押したら閉じるためのオーバーレイ */}
      <div
        className="menu-overlay"
        onPointerDown={handleOverlayPointerDown}
      />
    </>
  );
};
export default Menu;